module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkLocalAgencyAssignmentModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CLAA00))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CLAA01))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "selectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CLAA02,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedLocalAgency),
      callback: function($$v) {
        _vm.selectedLocalAgency = $$v
      },
      expression: "selectedLocalAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                " + _vm._s(agency.AgencyName) + "\n              ")])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA03) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAgencyAssignment()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA04) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c91682","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/CheckLocalAgencyAssignmentModal.vue
// module id = 1699
// module chunks = 1